// extracted by mini-css-extract-plugin
export var bodyRow = "_ef-d";
export var cardColumns = "_ef-e";
export var ellipsesOverflow = "_ef-2";
export var flatBottomCorners = "_ef-3";
export var flatTopCorners = "_ef-4";
export var headerActionsDropdown = "_ef-f";
export var headerBottomRow = "_ef-c";
export var headerTopRow = "_ef-b";
export var orderDetailsWrapper = "_ef-0";
export var orderInfoContainer = "_ef-1";
export var productDetails = "_ef-9";
export var productImage = "_ef-5";
export var responsiveTable = "_ef-8";
export var shipmentContainer = "_ef-a";
export var tableBottomLeft = "_ef-6";
export var tableBottomRight = "_ef-7";
export var trackingLink = "_ef-g";